import { Participation, TCompanyId, TLoanId } from '/src/lib/models';

/**
 * List Participations
 */
export type TListParticipationsRequest = {
  companyId?: TCompanyId;
  loanId?: TLoanId;
};

export type TListParticipationsResponse = Participation[];

/**
 * Create Participation
 */
export type TCreateParticipationRequest = {
  company: TCompanyId;
  participationPercentage: number;
  managementFee: number;
};
